"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Networks = exports.utils = exports.NativeScriptType = exports.TransactionSigningMode = exports.InvalidDataReason = exports.CertificateType = exports.AddressType = exports.Ada = void 0;
const errors_1 = require("./errors");
const invalidDataReason_1 = require("./errors/invalidDataReason");
Object.defineProperty(exports, "InvalidDataReason", { enumerable: true, get: function () { return invalidDataReason_1.InvalidDataReason; } });
const deriveAddress_1 = require("./interactions/deriveAddress");
const deriveNativeScriptHash_1 = require("./interactions/deriveNativeScriptHash");
const getExtendedPublicKeys_1 = require("./interactions/getExtendedPublicKeys");
const getSerial_1 = require("./interactions/getSerial");
const getVersion_1 = require("./interactions/getVersion");
const runTests_1 = require("./interactions/runTests");
const showAddress_1 = require("./interactions/showAddress");
const signOperationalCertificate_1 = require("./interactions/signOperationalCertificate");
const signTx_1 = require("./interactions/signTx");
const address_1 = require("./parsing/address");
const nativeScript_1 = require("./parsing/nativeScript");
const operationalCertificate_1 = require("./parsing/operationalCertificate");
const transaction_1 = require("./parsing/transaction");
const public_1 = require("./types/public");
Object.defineProperty(exports, "AddressType", { enumerable: true, get: function () { return public_1.AddressType; } });
Object.defineProperty(exports, "CertificateType", { enumerable: true, get: function () { return public_1.CertificateType; } });
Object.defineProperty(exports, "NativeScriptType", { enumerable: true, get: function () { return public_1.NativeScriptType; } });
Object.defineProperty(exports, "TransactionSigningMode", { enumerable: true, get: function () { return public_1.TransactionSigningMode; } });
const utils_1 = __importDefault(require("./utils"));
exports.utils = utils_1.default;
const assert_1 = require("./utils/assert");
const parse_1 = require("./utils/parse");
__exportStar(require("./errors"), exports);
__exportStar(require("./types/public"), exports);
const CLA = 0xd7;
function wrapConvertDeviceStatusError(fn) {
    return (...args) => __awaiter(this, void 0, void 0, function* () {
        try {
            return yield fn(...args);
        }
        catch (e) {
            if (e && e.statusCode) {
                throw new errors_1.DeviceStatusError(e.statusCode);
            }
            throw e;
        }
    });
}
function wrapRetryStillInCall(fn) {
    return (...args) => __awaiter(this, void 0, void 0, function* () {
        try {
            return yield fn(...args);
        }
        catch (e) {
            if (e &&
                e.statusCode &&
                e.statusCode === errors_1.DeviceStatusCodes.ERR_STILL_IN_CALL) {
                return yield fn(...args);
            }
            throw e;
        }
    });
}
function interact(interaction, send) {
    return __awaiter(this, void 0, void 0, function* () {
        let cursor = interaction.next();
        let first = true;
        while (!cursor.done) {
            const apdu = cursor.value;
            const res = first
                ? yield wrapRetryStillInCall(send)(apdu)
                : yield send(apdu);
            first = false;
            cursor = interaction.next(res);
        }
        return cursor.value;
    });
}
class Ada {
    constructor(transport, scrambleKey = "ADA") {
        this.transport = transport;
        const methods = [
            "getVersion",
            "getSerial",
            "getExtendedPublicKeys",
            "signTransaction",
            "deriveAddress",
            "showAddress",
            "deriveNativeScriptHash",
        ];
        this.transport.decorateAppAPIMethods(this, methods, scrambleKey);
        this._send = (params) => __awaiter(this, void 0, void 0, function* () {
            let response = yield wrapConvertDeviceStatusError(this.transport.send)(CLA, params.ins, params.p1, params.p2, params.data);
            response = utils_1.default.stripRetcodeFromResponse(response);
            if (params.expectedResponseLength != null) {
                assert_1.assert(response.length === params.expectedResponseLength, `unexpected response length: ${response.length} instead of ${params.expectedResponseLength}`);
            }
            return response;
        });
    }
    getVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            const version = yield interact(this._getVersion(), this._send);
            return { version, compatibility: getVersion_1.getCompatibility(version) };
        });
    }
    *_getVersion() {
        return yield* getVersion_1.getVersion();
    }
    getSerial() {
        return __awaiter(this, void 0, void 0, function* () {
            return interact(this._getSerial(), this._send);
        });
    }
    *_getSerial() {
        const version = yield* getVersion_1.getVersion();
        return yield* getSerial_1.getSerial(version);
    }
    runTests() {
        return __awaiter(this, void 0, void 0, function* () {
            return interact(this._runTests(), this._send);
        });
    }
    *_runTests() {
        const version = yield* getVersion_1.getVersion();
        return yield* runTests_1.runTests(version);
    }
    getExtendedPublicKeys({ paths }) {
        return __awaiter(this, void 0, void 0, function* () {
            parse_1.validate(parse_1.isArray(paths), invalidDataReason_1.InvalidDataReason.GET_EXT_PUB_KEY_PATHS_NOT_ARRAY);
            const parsed = paths.map((path) => parse_1.parseBIP32Path(path, invalidDataReason_1.InvalidDataReason.INVALID_PATH));
            return interact(this._getExtendedPublicKeys(parsed), this._send);
        });
    }
    *_getExtendedPublicKeys(paths) {
        const version = yield* getVersion_1.getVersion();
        return yield* getExtendedPublicKeys_1.getExtendedPublicKeys(version, paths);
    }
    getExtendedPublicKey({ path }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getExtendedPublicKeys({ paths: [path] }))[0];
        });
    }
    deriveAddress({ network, address }) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedParams = address_1.parseAddress(network, address);
            return interact(this._deriveAddress(parsedParams), this._send);
        });
    }
    *_deriveAddress(addressParams) {
        const version = yield* getVersion_1.getVersion();
        return yield* deriveAddress_1.deriveAddress(version, addressParams);
    }
    showAddress({ network, address }) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedParams = address_1.parseAddress(network, address);
            return interact(this._showAddress(parsedParams), this._send);
        });
    }
    *_showAddress(addressParams) {
        const version = yield* getVersion_1.getVersion();
        return yield* showAddress_1.showAddress(version, addressParams);
    }
    signTransaction(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedRequest = transaction_1.parseSignTransactionRequest(request);
            return interact(this._signTx(parsedRequest), this._send);
        });
    }
    *_signTx(request) {
        const version = yield* getVersion_1.getVersion();
        return yield* signTx_1.signTransaction(version, request);
    }
    signOperationalCertificate(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedOperationalCertificate = operationalCertificate_1.parseOperationalCertificate(request);
            return interact(this._signOperationalCertificate(parsedOperationalCertificate), this._send);
        });
    }
    *_signOperationalCertificate(request) {
        const version = yield* getVersion_1.getVersion();
        return yield* signOperationalCertificate_1.signOperationalCertificate(version, request);
    }
    deriveNativeScriptHash({ script, displayFormat }) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedScript = nativeScript_1.parseNativeScript(script);
            const parsedDisplayFormat = nativeScript_1.parseNativeScriptHashDisplayFormat(displayFormat);
            return interact(this._deriveNativeScriptHash(parsedScript, parsedDisplayFormat), this._send);
        });
    }
    *_deriveNativeScriptHash(script, displayFormat) {
        const version = yield* getVersion_1.getVersion();
        return yield* deriveNativeScriptHash_1.deriveNativeScriptHash(version, script, displayFormat);
    }
}
exports.Ada = Ada;
exports.default = Ada;
exports.Networks = {
    Mainnet: {
        networkId: 0x01,
        protocolMagic: 764824073,
    },
    Testnet: {
        networkId: 0x00,
        protocolMagic: 1097911063,
    },
};
//# sourceMappingURL=data:application/json;base64,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